<template>
  <div>
    <div class="cs-rgist-main">
      <div class="tab-design cs">
        <ul>
          <li>
            <router-link
              :to="{ name: 'CsRegist' }"
              class="router-link-deactive"
              >{{ $t("inquiry.submit") }}</router-link
            >
          </li>
          <li>
            <router-link :to="{ name: 'CsList' }" class="router-link-active">{{
              $t("inquiry.inquiryList")
            }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- CS VIEW//S -->
    <div class="board-view">
      <!-- 질문// S-->
      <div class="board-top">
        <div class="text-left">
          <h4>{{ title }}</h4>
          <span v-html="nl2br(contents)"></span>
        </div>
        <div class="text-right">
          <span class="date">{{ regDate }}</span>
        </div>
      </div>
      <!-- 질문// E-->
      <!-- 답변// S-->
      <div class="board-bottom">
        <div class="clearfix">
          <h3 class="pull-left">{{ $t("inquiry.answerContent") }}</h3>
        </div>
        <div class="text-left">
          <p v-html="nl2br(answer)" v-if="answerStatus"></p>
          <p v-if="!answerStatus">{{ $t("inquiry.preparing") }}</p>
        </div>
      </div>
      <!-- 답변// E-->
    </div>
    <!-- CS VIEW//E -->
  </div>
</template>
<script>
import Api from "@/common/Api";
import Moment from "moment";
export default {
  mounted() {
    this.getQnaView();
  },
  data() {
    return {
      actives: 0,
      title: "",
      contents: "",
      answer: "",
      regDate: "",
      category: "",
      regDate: "",
      answerStatus: false,
    };
  },
  methods: {
    getQnaView() {
      const params = {
        type: 5,
        itemId: this.$route.params.id,
      };
      Api.Board.getItems(params)
        .then((response) => {
          const data = response.body;
          (this.title = data.title),
            (this.category = this.cateString(data.category)),
            (this.contents = data.contents),
            (this.regDate = Moment(data.regDate).format("YYYY-MM-DD"));
          this.answer = data.answer;
          if (data.answerStatus) {
            this.answerStatus = true;
          }
        })
        .catch((err) => {});
    },
    cateString(cate) {
      switch (cate) {
        case "1":
          return this.$t("inquiry.menu[1]");
          break;
        case "2":
          return this.$t("inquiry.menu[2]");
          break;
        case "3":
          return this.$t("inquiry.menu[3]");
          break;
        case "4":
          return this.$t("inquiry.menu[4]");
          break;
        case "5":
          return this.$t("inquiry.menu[5]");
          break;
        case "6":
          return this.$t("inquiry.menu[6]");
          break;
      }
    },
    nl2br(str) {
      console.log(str);
      return str.replace(/(?:\r\n|\r|\n)/g, "<br />");
    },
  },
};
</script>
<style></style>
